// extracted by mini-css-extract-plugin
export var component = "hr-module--component--GRXmt";
export var isLeft = "hr-module--isLeft--piynY";